import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import MessagesTemplateListComponent from './MessagesTemplateListComponent';

import * as commonSelectors from '../Shared/selectors';

const MessagesTemplateListContainer = (props) => {
  const {
    nextMessages,
    getThreadsList,
    currentChatId,
    onMarkChatAsRead,
    messageUrl,
  } = props;

  const history = useHistory();

  const loadNextMessages = () => {
    if (!isEmpty(nextMessages)) {
      getThreadsList(nextMessages);
    }
  };

  const setCurrentChat = (id) => {
    if (id && id !== currentChatId) {
      getThreadsList({}, true);
      onMarkChatAsRead && onMarkChatAsRead(id);
      history.replace(`${messageUrl}/${id}`);
    }
  };

  return (
    <MessagesTemplateListComponent
      loadNextMessages={loadNextMessages}
      setCurrentChat={setCurrentChat}
      {...props}
    />
  );
};

MessagesTemplateListContainer.defaultProps = {
  nextMessages: null,
  currentChatId: null,
  onMarkChatAsRead: null,
};

MessagesTemplateListContainer.propTypes = {
  nextMessages: PropTypes.shape({
    limit: PropTypes.number,
    offset: PropTypes.number,
  }),
  getThreadsList: PropTypes.func.isRequired,
  currentChatId: PropTypes.number,
  onMarkChatAsRead: PropTypes.func,
  messageUrl: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { common } = state;
  const isLoading = !!common?.loading?.length;
  const currentChatId = Number(ownProps?.match?.params?.id ?? null);
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  return {
    isLoading,
    currentChatId,
    isMobileScreen,
  };
};

export default connect(mapStateToProps, null)(MessagesTemplateListContainer);
